module.exports = __webpack_public_path__ + "img/poster.23fd5166.png";